import { render, staticRenderFns } from "./TaxiDrivers.vue?vue&type=template&id=51332813&lang=pug"
import script from "./TaxiDrivers.vue?vue&type=script&lang=js"
export * from "./TaxiDrivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports